import { BaseModel } from './base-model';
import { ModelConfig } from './model-config';

export class Customer extends BaseModel{

  name() {
    return this.get("firstName") + " " + this.get("lastName");
  }

  static create(attribs: Object) {
    return new Customer(attribs);
  }

  constructor(loadAttribs: any) {

      // define permitted attributes.
      let config = new ModelConfig();
      config.permittedAttribs = [

          // profile attribs.
          "firstName", "lastName", "email", "phone", "leadSource", "dob",

          // vehicle attribs.
          "vehicleMake", "vehicleModel", "vehicleYear", "licensePlate",

          // subscription attribs.
          "qrFilename", "subscriptionId",

          // integration attribs.
          "CONTACTID", "ACCOUNTID", "contactid",

          // misc
          "meta",

          // V2 Attribs --------------------------------
          "id"
      ];

      // instantiate BaseModel.
      super(config);

      // load any passed in attribs.
      if(typeof loadAttribs === "object" && Object.keys(loadAttribs).length)
      {
        if(loadAttribs.hasOwnProperty("dateOfBirth") && !loadAttribs.hasOwnProperty("dob"))
        {
          loadAttribs.dob = loadAttribs.dateOfBirth;
        }
        super.load(loadAttribs);
      }
  }
}



// WEBPACK FOOTER //
// ./src/models/customer.ts